/**
 * Creates a debounce for a specific function
 * @param fn the function to be debounced
 * @param delay amount of time that must elapse before the function is called
 */
function debounce(fn, delay) {
    let timeoutID = null;
    return function (...args) {
        clearTimeout(timeoutID);
        timeoutID = window.setTimeout(() => fn.apply(this, args), delay);
    };
}

export { debounce };
//# sourceMappingURL=debounce.js.map
